import React from "react";
import { useSelector } from "react-redux";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const ReasonCallEnded = () => {
  const analytics = useSelector((state) => state.analytics.data);
  const endedReasonStats = analytics?.endedReasonStats || [];

  const labels = endedReasonStats.map((item) => item.reason);
  const dataValues = endedReasonStats.map((item) => item.count);

  const backgroundColors = [
    "#FF6384", "#36A2EB", "#FFCE56", "#6f42c1", "#20c997",
    "#f66d9b", "#fd7e14", "#198754", "#6610f2", "#0dcaf0",
    "#e83e8c", "#adb5bd"
  ];

  const data = {
    labels,
    datasets: [
      {
        label: "Call End Reasons",
        data: dataValues,
        backgroundColor: backgroundColors,
        borderRadius: 6,
        barThickness: 30,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.raw} Calls`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 12,
          },
          callback: function (value, index, ticks) {
            const label = this.getLabelForValue(value);
            return label.length > 10 ? label.slice(0, 10) + "..." : label;
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 10,
          font: {
            size: 12,
          },
        },
      },
    },
  };

  return (
    <div className='col-xxl-6'>
      <div className='card h-100 w-auto'>
        <div className='card-body p-24'>
          <div className='d-flex align-items-center flex-wrap gap-2 justify-content-between'>
            <h6 className='mb-2 fw-bold text-lg mb-0'>Reason Call Ended</h6>
          </div>
          <p className="mb-2 text-sm">
            The breakdown of reasons why calls were ended or completed, grouped for analysis.
          </p>

          <div style={{ width: "100%", overflowX: "auto", marginTop: "24px" }}>
            <div style={{ minWidth: "400px", width: "100%", height: "240px" }}>
              <Bar data={data} options={options} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReasonCallEnded;
